export default {
  header: 'Esta semana',
  metrics: {
    points: 'Puntos',
    visits: 'Visitas',
    in_store_sign_ups: 'Registros en tienda',
    rewards_redeemed: 'Recompensas canjeadas',
  },
};
